import { useEffect, useState } from 'react';

/**
 * Per-mount launch-window flags, not app-wide state: every caller gets its own instance, so one consumer cannot
 * signal another. `isInitialLoad` clears after 100 ms (or via `resetInitialLoad`), `isInitialRedirect` after 200 ms.
 */
export const useAppLaunchDetection = () => {
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isInitialRedirect, setIsInitialRedirect] = useState(true);

  useEffect(() => {
    // After the first render, mark that we're no longer in initial load
    const timer = setTimeout(() => {
      setIsInitialLoad(false);
      // Also end the initial redirect phase after a bit longer to allow for router redirects
      setTimeout(() => {
        setIsInitialRedirect(false);
      }, 100);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Reset the initial load state after it's been consumed
  const resetInitialLoad = () => {
    setIsInitialLoad(false);
  };

  return {
    isInitialLoad,
    isInitialRedirect,
    resetInitialLoad,
  };
};
